// The details for the Package page are closed on mobile but open on desktop.
// This is a media query for that
export default function detailsBreakpoint() {
    const seriesDetails = '.series-item__details';
    const mq = window.matchMedia('(min-width: 800px)');

    function openCloseDetails() {
        document.querySelectorAll(seriesDetails).forEach(d => {
            if (mq.matches && !d.open) d.open = true;
            if (!mq.matches && d.open) d.open = false;
        });
    }

    if (seriesDetails) {
        openCloseDetails();

        if (mq.addEventListener) {
            mq.addEventListener('change', openCloseDetails);
        }
    }
}
